module.exports = __webpack_public_path__ + "img/cost-section.919b261e.svg";